var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Wrapper } from '../../SbGlobal/styles';
import { Container, TileTitle } from './styles';
import FontIconSingle from 'components/FontIcons/FontIcon';
export var TileWidget = function (_a) {
    var option = _a.option, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var isNew = useMemo(function () { return option.value.includes('new:'); }, [option.value]);
    return (_jsx(Container, __assign({ disabled: disabled, onClick: onClick }, { children: _jsxs(Wrapper, __assign({ center: true, gap: 4 }, { children: [(option === null || option === void 0 ? void 0 : option.icon) && (_jsx(FontIconSingle, { size: isNew ? 24 : 16, icon: option.icon })), _jsx(TileTitle, { children: option.label })] })) })));
};
